import React from 'react';
// import PropTypes from 'prop-types';
import { InputText } from 'primereact/inputtext';
import {getNewCommodityDetail} from './commodityReducer'
import "../../style/commodities.css";

const CommoditySymbolItem = (props) => {
    let isC3Type = props.selectedCommodityType === 'C3';
    const validityProps = {
        pattern:  isC3Type ? "^C3:[a-zA-Z0-9]+": "[a-zA-Z^]+",
        onInvalid: e => {
            let message = isC3Type ? "Should start with C3: followed by alphanumeric" : "Can contain alphabets and ^"
            e.target.setCustomValidity(message);
        },
        onChange: e => {
            let ele = e.target;
            ele.setCustomValidity("")
            if (ele.checkValidity()) {
                // e.target.setCustomValidity("")
            } else {
                // e.target.setCustomValidity("Should start with C3:");
                ele.reportValidity();
            }
        }
    };
    return props.isEditing || props.isAdding ? <div style={{border: 0, padding: 0}} className="grid-item">
        <span className="p-input-icon-right">
            <i className="pi pi-times-circle" onClick={(event) => {props.onItemDelete(event, props.index)}}/>
            <InputText
                name="commoditySymbolToAdd"
                required
                defaultValue={props.value}
                {...validityProps}
                type='text'
                onKeyDown={(e) => {
                    let ele = e.target;
                    ele.setCustomValidity("")
                    if (ele.checkValidity()) {
                        // e.target.setCustomValidity("")
                        if (e.key === 'Enter') {
                            if (props.isAdding) {
                                props.onItemAdd(e, e.target.value, props.index)   
                            } else {
                                props.onItemChange(e, e.target.value, props.index)
                            }
                        }
                    } else {
                        // e.target.setCustomValidity("Should start with C3:");
                        ele.reportValidity();
                    }
                    
                }} 
                onBlur={(e) => {
                    let ele = e.target;
                    ele.setCustomValidity("")
                    e.target.reportValidity();
                    if (ele.checkValidity()) { 
                        if (props.isAdding) {
                            props.onItemAdd(e, e.target.value, props.index)
                        } else {
                            props.onItemChange(e, e.target.value, props.index)
                        } 
                    } else {
                        ele.reportValidity();
                    }
                                       
                }}
                maxLength={50}
                 />
        </span>
        </div> : <span className="p-input-icon-right">
            <i className={`pi ${props.isDeleting ? "pi-replay": "pi-times-circle"}`} onClick={(event) => {props.onItemDelete(event, props.index)}}/>
            <div className="grid-item">{props.value}</div>
        </span>
}

export const CommoditySymbols = (props) => {
    const onCommodityChange = (event, value, index) => {
        const updatedValue = [...props.value];
        let itemToUpdate = updatedValue[index];
        if (props.displayLabel) {
            itemToUpdate = {...itemToUpdate}
            itemToUpdate[props.displayLabel] = value;
        }
        if (props.onEdit) {
            props.onEdit({
                originalEvent: event,
                value: itemToUpdate
            });
        }
        if(props.onChange) {
            const updatedValue = [...props.value];
            let itemToUpdate = updatedValue[index];
            if (props.displayLabel) {
                itemToUpdate = {...itemToUpdate}
                itemToUpdate[props.displayLabel] = value;
            }
            updatedValue.splice(index, 1, itemToUpdate);
            props.onChange({
                originalEvent: event,
                value: updatedValue,
                stopPropagation : () =>{},
                preventDefault : () =>{},
                target: {
                    name: props.name,
                    id: props.id,
                    value : updatedValue
                }
            })
        }
    }

    const onCommodityAdd = (event, value) => {
        const items = [...props.value];
        let itemToAdd = value;
        if (props.displayLabel) {
            itemToAdd = getNewCommodityDetail()
            itemToAdd[props.displayLabel] = value;
        }
        if (props.onAdd) {
            props.onAdd({
                originalEvent: event,
                value: itemToAdd
            });
        }
        if(props.onChange) {
            items.unshift(itemToAdd);
            props.onChange({
                originalEvent: event,
                value: items,
                stopPropagation : () =>{},
                preventDefault : () =>{},
                target: {
                    name: props.name,
                    id: props.id,
                    value : items
                }
            })
        }
    }
    const onCommodityDelete = (event, index) => {
        const items = [...props.value];
        const removedItem = items.splice(index, 1);
        if (props.onRemove) {
            props.onRemove({
                originalEvent: event,
                value: removedItem
            });
        }
        if(props.onChange) {
            props.onChange({
                originalEvent: event,
                value: items,
                stopPropagation : () =>{},
                preventDefault : () =>{},
                target: {
                    name: props.name,
                    id: props.id,
                    value : items
                }
            })
        }
    }

    return <div className="grid-container" id={props.id}>
        {(props.isAdding || (props.value && props.value.length === 0))&& <CommoditySymbolItem 
            value={''}
            isAdding={props.isAdding || props.value.length === 0}
            index={0}
            onItemAdd={onCommodityAdd}
            onItemDelete={onCommodityDelete}
            selectedCommodityType={props.selectedCommodityType}
            isDeleting={props.isDeleting} /> 
        }
        {props.value?.map((value, index, valueArr) => {
            const val = props.displayLabel ? value[props.displayLabel] : value;
            return <CommoditySymbolItem 
                key={val} 
                value={val} 
                isEditing={props.isEditing}
                index={index} 
                onItemChange={onCommodityChange}
                onItemDelete={onCommodityDelete}
                selectedCommodityType={props.selectedCommodityType}
                isDeleting={props.isDeleting} />
        })}
    </div>
}